export default {
  Login: "Login",
  Email: "Email",
  Password: "Password"
};
